import { useMutation } from '@tanstack/react-query';
import { passwordApi, type ChangePasswordRequest } from '../api/password.api';

export function useChangePassword() {
  return useMutation({
    mutationFn: (body: ChangePasswordRequest) => passwordApi.change(body),
    meta: { invalidates: false },
  });
}
